import axios from 'axios';
import Store from './Store';
import { applyBearerOrCookie } from './authStrategy';

const CREDENTIAL = '/credential';

const {
  VUE_APP_DRIVE_SERVICE_URL,
  VUE_APP_AUTH_SERVICE_URL,
// eslint-disable-next-line no-undef
} = process.env;

function withAuth(config, token = Store.getToken()) {
  return applyBearerOrCookie(config, token);
}

export default {
  name: 'DrivesService',

  async findAll() {
    const url = `${VUE_APP_DRIVE_SERVICE_URL}${CREDENTIAL}`;

    return axios(withAuth({
      url,
      method: 'get',
    }));
  },
  create(drive) {
    const url = `${VUE_APP_DRIVE_SERVICE_URL}${CREDENTIAL}`;

    return axios(withAuth({
      url,
      method: 'post',
      data: drive,
    }));
  },
  update(drive) {
    const url = `${VUE_APP_DRIVE_SERVICE_URL}${CREDENTIAL}/${drive.id}`;

    return axios(withAuth({
      url,
      method: 'put',
      data: drive,
    }));
  },
  delete(id) {
    const url = `${VUE_APP_DRIVE_SERVICE_URL}${CREDENTIAL}/${id}`;
    return axios(withAuth({
      url,
      method: 'delete',
    }));
  },
  loadTokenFull(token = Store.getToken()) {
    const url = `${VUE_APP_AUTH_SERVICE_URL}/token/full`;

    return axios(withAuth({
      url,
      method: 'get',
    }, token));
  },

  findAllProfiles() {
    return [
      { id: 1, description: 'Profile 1' },
      { id: 2, description: 'Profile 2' },
      { id: 3, description: 'Profile 3' },
      { id: 4, description: 'Profile 4' },
      { id: 5, description: 'Profile 5' },
      { id: 6, description: 'Profile 6' },
      { id: 7, description: 'Profile 7' },
      { id: 8, description: 'Profile 8' },
      { id: 9, description: 'Profile 9' },
      { id: 10, description: 'Profile 10' },
      { id: 11, description: 'Profile 11' },
    ];
  },

  findAllGroups() {
    return [
      { id: 1, description: 'Group 1' },
      { id: 2, description: 'Group 2' },
      { id: 3, description: 'Group 3' },
    ];
  },

  findAllUsers() {
    return [
      { id: 1, description: 'User 1' },
      { id: 2, description: 'User 2' },
      { id: 3, description: 'User 3' },
    ];
  },

};
